import { useState } from "react";
export const useDataLoading = (initData) => {
    const [data, setDataState] = useState(initData || {
        data: null,
        loading: true,
    });
    const setLoading = (loading) => setDataState((prev) => ({ ...prev, loading }));
    const setData = (dataArg) => setDataState({ loading: false, data: dataArg });
    return { ...data, setLoading, setData };
};
